export const MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: '8px',
      boxShadow: '0px 2px 10px 0px hsba(0, 0%, 0%, 0.05)',
    },
  },
};
